import CustomFormViewerComponent from './Component'
import CustomFormViewerManagerProvider from './contexts/CustomFormViewerManager/Provider'
import { CustomFormViewerProps } from '../../types'

export default function CustomFormViewer(props: CustomFormViewerProps) {
  return (
    <CustomFormViewerManagerProvider {...props}>
      <CustomFormViewerComponent />
    </CustomFormViewerManagerProvider>
  )
}
